import { Word } from "../../stores/word/Word";
import { IWordService } from "./IWordService";

export class DummyWordService implements IWordService {
  getWords(wordsCallback: (words: Word[]) => void) {
    wordsCallback(this.getDummyData());
  }

  private getDummyData(): Word[] {
    return [
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" },
      { word: "cookie", originalWord: "koekje", originalLanguage: "Dutch" },
      {
        word: "armadillo",
        originalWord: "armadillo",
        originalLanguage: "Spanish"
      },
      { word: "ranch", originalWord: "ranch", originalLanguage: "Spanish" },
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" },
      { word: "cookie", originalWord: "koekje", originalLanguage: "Dutch" },
      {
        word: "armadillo",
        originalWord: "armadillo",
        originalLanguage: "Spanish"
      },
      { word: "ranch", originalWord: "ranch", originalLanguage: "Spanish" },
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" },
      { word: "cookie", originalWord: "koekje", originalLanguage: "Dutch" },
      {
        word: "armadillo",
        originalWord: "armadillo",
        originalLanguage: "Spanish"
      },
      { word: "ranch", originalWord: "ranch", originalLanguage: "Spanish" },
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" },
      { word: "cookie", originalWord: "koekje", originalLanguage: "Dutch" },
      {
        word: "armadillo",
        originalWord: "armadillo",
        originalLanguage: "Spanish"
      },
      { word: "ranch", originalWord: "ranch", originalLanguage: "Spanish" },
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" },
      { word: "cookie", originalWord: "koekje", originalLanguage: "Dutch" },
      {
        word: "armadillo",
        originalWord: "armadillo",
        originalLanguage: "Spanish"
      },
      { word: "ranch", originalWord: "ranch", originalLanguage: "Spanish" },
      { word: "booze", originalWord: "būsen", originalLanguage: "Dutch" }
    ].map(dummyWord => {
      const word = new Word(dummyWord.word);
      word.originalWord = dummyWord.originalWord;
      word.originalLanguage = dummyWord.originalLanguage;
      word.dictionaryUrl = "";
      word.imageUrl = "";
      word.city = "";
      word.country = "";
      word.wordType = "";

      return word;
    });
  }
}



// WEBPACK FOOTER //
// ./services/word/DummyWordService.ts